import InstructionsPanel from './InstructionsPanel';
import ButtonFixedPosition from 'app/ui/buttons/ButtonFixedPosition';
import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';

import { GAME_SFX_INSTRUCTION_WOOSH } from 'app/constants/GameSFX';

class Instructions extends Phaser.Group {
  constructor({ game, closeBtnData }) {
    super(game);

    this.game.track(AppTrackingEvents.VIEW_SCREEN_INSTRUCTIONS);

    const sheet = 'instructions';
    this.panels = [
      new InstructionsPanel({ id: 'instructions01', game: this.game, sheet: sheet, index: 0 }),
      new InstructionsPanel({ id: 'instructions02', game: this.game, sheet: sheet, index: 1 }),
      new InstructionsPanel({ id: 'instructions03', game: this.game, sheet: sheet, index: 2 }),
      new InstructionsPanel({ id: 'instructions04', game: this.game, sheet: sheet, index: 3 }),
    ];

    this.background = this.game.make.image(0, 0, 'bg_fade');
    this.background.anchor.set(0);
    this.add(this.background);
    this.background.inputEnabled = true;
    this.background.input.priorityID = 0;
    this.background.input.useHandCursor = false;

    this.panelContainer = this.game.make.group();
    this.add(this.panelContainer);

    this.addPanels();
    this.createCloseButton(closeBtnData);
    this.positionElements();
  }

  createCloseButton(data) {
    if (data) {
      const { id, sfx_id, skin, ariaLabelID } = data;
      const opts = { game: this.game, id, x: 0, y: 0, sfx_id, skin, ariaLabelID };
      this.closeButton = new ButtonFixedPosition(opts);
      this.closeButton.onInputDown.add(this.handleClose, this);
      const x = this.panels[0].width + 100;
      const y = this.panels[this.panels.length - 1].y + this.panels[this.panels.length - 1].height + 40;
      this.closeButton.position.set(x, y);
    }
  }

  handleClose() {
    this.game.controller.closeInstructions();
  }

  positionElements() {
    this.background.width = this.game.width;
    this.background.height = this.game.height;
    this.panelContainer.position.set((this.game.width - this.panelContainer.width) * 0.5, this.game.height * 0.04);
  }

  activate() {
    this.game.scale.onSizeChange.add(this.positionElements, this);
    const childIndex = this.game.stage.children.length;
    this.game.stage.addChildAt(this, childIndex);
    this.cnt = 0;
    this.timer = this.game.time.events.repeat(Instructions.ANIM_DURATION, this.panels.length, this.showPanel, this);
    this.showPanel();
  }

  deactivate() {
    this.game.scale.onSizeChange.remove(this.positionElements, this);
    this.game.world.remove(this);
  }

  addPanels() {
    for (const [index, panel] of this.panels.entries()) {
      const content = Instructions.content[index];
      panel.init(content);
      this.panelContainer.add(panel);
    }
  }

  showPanel() {
    this.game.sounds.playSFX(GAME_SFX_INSTRUCTION_WOOSH);
    if (this.cnt < this.panels.length) {
      this.panels[this.cnt].show();
      this.cnt++;
    } else {
      this.panelContainer.add(this.closeButton);
    }
  }

  destroy() {
    if (this.timer) {
      this.game.time.events.remove(this.timer);
    }
    this.panelContainer.destroy(true);
    this.panelContainer = null;
    for (let panel of this.panels) {
      panel.destroy();
      panel = null;
    }
    this.closeButton.destroy(true);
    this.closeButton = null;
    this.background = null;
    this.deactivate();
    super.destroy(true);
  }
}

Instructions.content = [
  { position: { x: 0, y: 0 } },
  { position: { x: 75, y: 165 } },
  { position: { x: 265, y: 220 } },
  { position: { x: 75, y: 400 } },
];
Instructions.ANIM_DURATION = 1000;
export default Instructions;
